import { MatrixCell } from "./MatrixCell";
import { MatrixObject } from "./MatrixObject";

export class MatrixRow {
    cells: MatrixCell[];
    tr: HTMLTableRowElement;
    matrixObject: MatrixObject;
    rowIndex: number;
    isMultiRowItem?: boolean;
    multiRowItemValue?: number;
    hasMultiRowDeleteCommand?: Boolean;

    constructor(matrixObject: MatrixObject, rowIndex: number) {
        this.matrixObject = matrixObject;
        this.cells = new Array<MatrixCell>();
        this.rowIndex = rowIndex;
        this.isMultiRowItem = false;
        this.hasMultiRowDeleteCommand = true;
    }

    addCell(type: string, value: string, colSpan: number, rowSpan: number, width: number): void {
        var cell = new MatrixCell(type, this);
        cell.value = value;
        if (colSpan && colSpan > 0)
            cell.colSpan = colSpan;
        if (rowSpan && rowSpan > 0)
            cell.rowSpan = rowSpan;
        cell.width = width;
        if (cell.width < 30)
            cell.width = 30;
        cell.rowIndex = this.rowIndex;
        cell.colIndex = this.cells.length;
        this.cells.push(cell);
    }

    createRow(tbody: HTMLTableSectionElement, trElement: HTMLTableRowElement): void {
        // create or set DOM element
        if (trElement == null)
            this.tr = document.createElement('tr');
        else
            this.tr = trElement;

        // create all cells
        for (var i = 0; i < this.cells.length; i++) {
            if (this.cells[i].isVisible()) {
                this.cells[i].createCell(null);
                this.tr.appendChild(this.cells[i].td);
            }
        }

        // add DOM element
        if (trElement == null)
            tbody.appendChild(this.tr);
    }

    updateModelState(rowIndex: number): void {
        // store index
        this.rowIndex = rowIndex;

        // update cells
        for (var colIndex = 0; colIndex < this.cells.length; colIndex++)
            this.cells[colIndex].updateModelState(this, rowIndex, colIndex);
    }

    getCellIndex(colIndex: number): number {
        var result = 0;
        for (var i = 0; i < colIndex; i++) {
            if (this.cells[i].type != "h")
                result++;
        }
        return result;
    }

    saveValues(): void {
        for (var i = 0; i < this.cells.length; i++)
            this.cells[i].saveValues();
    }

    static fromJson(object: any, parentMatrixObject: MatrixObject, index: number): MatrixRow {
        let res = <MatrixRow>Object.assign(new MatrixRow(parentMatrixObject, index), object);
        res.cells = object.cells ? object.cells.map(c => MatrixCell.fromJson(c, res)) : [];
        return res;
    }
}
